import gql from 'graphql-tag'

export const SEARCH_SALES_USERS = gql`
    query Users($salesFilter: String!){
        Users(where: {_and: [{name: {_ilike: $salesFilter}},{userTypeId: {_eq: "03185af3-fd06-42cb-91d9-b8081ee1f704"}}]}){
            name
            id
        }
    }`

export const SEARCH_PREFERRED_VOLUME_PARTNERS = gql`
    query Organizations($preferredVPFilter: String!){
        Organizations1: Organizations(where: {_and: [{status:{_eq: "Active"}},{name: {_ilike: $preferredVPFilter}},{partnerType: {_in: ["3260ebcf-8944-4dc1-a003-9997b0e07811","9260ebcf-8944-4dc1-a003-9997b0e07811"]}}]}){
            name
            mobile
            partnerCode
            id
        }
    }`

export const GET_PREFERRED_DISTRIBUTORS_FOR_RD = gql`
    query Organizations{
        preferredDistributorsForRD: Organizations(where: {status:{_eq: "Active"},partnerType: {_in: ["9260ebcf-8944-4dc1-a003-9997b0e07811"]}}){
            name
            mobile
            email
            partnerCode
            id
        }
    }`
export const GET_PREFERRED_DISTRIBUTORS_FOR_VAD = gql`
    query Organizations{
        preferredDistributorsForVAD: Organizations(where: {status:{_eq: "Active"},partnerType: {_in: ["917370fd-9532-4f84-bd30-9b6f0777e206","9260ebcf-8944-4dc1-a003-9997b0e07811"]}}){
            name
            mobile
            email
            partnerCode
            id
        }
    }`
export const GET_PREFERRED_DISTRIBUTORS_FOR_VAP = gql`
    query Organizations{
        preferredDistributorsForVAP: Organizations(where: {status:{_eq: "Active"},partnerType: {_in: ["3260ebcf-8944-4dc1-a003-9997b0e07811","917370fd-9532-4f84-bd30-9b6f0777e206","9260ebcf-8944-4dc1-a003-9997b0e07811"]}}){
            name
            mobile
            email
            partnerCode
            id
        }
    }`
export const GET_PREFERRED_DISTRIBUTORS_FOR_VP = gql`
    query Organizations{
        preferredDistributorsForVP: Organizations(where: {status:{_eq: "Active"},partnerType: {_in: ["3260ebcf-8944-4dc1-a003-9997b0e07811","917370fd-9532-4f84-bd30-9b6f0777e206","9260ebcf-8944-4dc1-a003-9997b0e07811"]}}){
            name
            mobile
            email
            partnerCode
            id
        }
    }`
